import { render, staticRenderFns } from "./DoctorCard.vue?vue&type=template&id=30cc60bc&scoped=true&"
import script from "./DoctorCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./DoctorCard.vue?vue&type=style&index=0&id=30cc60bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cc60bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30cc60bc')) {
      api.createRecord('30cc60bc', component.options)
    } else {
      api.reload('30cc60bc', component.options)
    }
    module.hot.accept("./DoctorCard.vue?vue&type=template&id=30cc60bc&scoped=true&", function () {
      api.rerender('30cc60bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/components/DoctorCard.vue"
export default component.exports